import { render, staticRenderFns } from "./GroupBox.vue?vue&type=template&id=39cf538a&scoped=true"
import script from "./GroupBox.vue?vue&type=script&lang=js"
export * from "./GroupBox.vue?vue&type=script&lang=js"
import style0 from "./GroupBox.vue?vue&type=style&index=0&id=39cf538a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf538a",
  null
  
)

export default component.exports